export const DEALERLESS_OEM = ['tesla', 'rivian', 'lucid', 'fisker'];
export const DEALERLESS_OEM_TRIAL = ['polestar', 'vinfast'];

export const NO_ESP_OEM = [
  'acura',
  'alfa-romeo',
  'bmw',
  'cadillac',
  'honda',
  'infiniti',
  'jaguar',
  'land-rover',
  'lincoln',
  'mercedes-benz',
  'porsche',
  'toyota',
  'volkswagen',
];
